export class TerminalUtil {

  static getTerminalTypeId(terminalType:string) {
    // return terminalType ==='Android'?2:1;
    switch(terminalType) {
      case 'Windows': return 1;
      case 'Android': return 2;
      case 'Web': return 3;
    }
  }

  static extractTerminal(val:string):string {
    if(val.includes('iBrand')) {
      return val.substr(6).trim();
    }

    return val;
  }
}
